import { React } from 'react';
import styled from 'styled-components';
import { useTheme } from '../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../Styles/theme';

import { ReactComponent as LeftArrowSvg } from '../../image/LeftArrow.svg';
import NewNumberOfMonthSelectBox from './NewNumberOfMonthSelectBox';

export default function NewMemberShipValidity(props) {
  const { value, setValue, validityUnit, setValidifyUnit } = props;

  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

	function handleChange(e) {
    const regex = /[^0-9]/g;
    const result = e.target.value.replace(regex, 0);

    if (e.target.value === '') setValue(0);
		else setValue(parseInt(result));
	}

	function handleFocus(e) {

	}

  function upButtonClick() {
    setValue(value + 1);
  }

  function downButtonClick(){
    if (value > 0) setValue(value - 1);
  }

  return (
    <TopLevelWrapper>
      <Input
        placeholder={0}
        value={value}
        onChange={handleChange}
        onFocus={handleFocus}/>
      <ButtonWrapper>
        <Button onClick={upButtonClick}><StyledArrow isUp={true} /></Button>
        <Button onClick={downButtonClick}><StyledArrow isUp={false} /></Button>
      </ButtonWrapper>
      <NewNumberOfMonthSelectBox unit={validityUnit} setUnit={setValidifyUnit}/>
    </TopLevelWrapper>
  )
}


const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: 100%;

  transition: all 0.3s ease-in-out;
`;

const Input = styled.input`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  // padding: 0 8px 0 8px;
  padding: 0px 8px;
  margin: 0 4px 0 0;

  // width: calc(35.91% - 18px);
  width: 62px;
  height: 30px;

  border: 1px solid ${props => props.theme.line};
  border-radius: 8px;
  background-color: ${props => props.theme.subBackground};

  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.text};
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 4px;
  margin-right: 4px;
`;

const Button = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 30px;
  height: 30px;

  border: 1px solid ${props => props.theme.buttonFill};
  border-radius: 8px;
  background-color: ${props => props.theme.buttonFill};

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const StyledArrow = styled(LeftArrowSvg)`
  width: 9.6px;
  height: 17.7px;

  transform: ${props => props.isUp ? 'rotate(90deg)' : 'rotate(-90deg)'};

  & path {
    fill: ${props => props.theme.subText};
  }
`;